import style from './style.scss';

/**
 * The Loader component displays a loading placeholder.
 *
 * props:
 * - text (optional): the loading message. If not provided, default message is used.
 */
const Loader = props => {
	return (
		<div class={style.loader}>{ props.text || 'Loading' }</div>
	);
};

export default Loader;



// WEBPACK FOOTER //
// ./components/loader/index.js